import React from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeProvider as CSThemeProvider } from '@csinstruments/cs-react-theme'
import { environment } from 'app/helpers/environment'

type Props = {
  children: React.ReactNode
}
export const theme = environment.STAGE === 'neutral' ? 'neutralLight' : 'csLight'
export const ThemeProvider: React.FC<Props> = ({ children }: Props) => {
  const { i18n } = useTranslation('common')
  return (
    <CSThemeProvider theme={theme} language={i18n.language.toLowerCase()}>
      {children}
    </CSThemeProvider>
  )
}
